import InfoCircleFill from "@hl/base-components/lib/assets/icons.generated/InfoCircleFill";
import { Group, Stack, Text, Tooltip } from "@mantine/core";

const InfoTooltip: React.FC<{ children: string }> = ({ children }) => (
  <Tooltip label={children} withArrow>
    <InfoCircleFill />
  </Tooltip>
);

export const SaleData = ({
  label,
  info,
  value,
  suffix,
}: {
  label: string;
  info?: string;
  value: string | React.ReactNode;
  suffix?: string;
}) => (
  <Stack spacing={4}>
    <Group spacing={4}>
      <Text size="sm">{label}</Text>
      {info && <InfoTooltip>{info}</InfoTooltip>}
    </Group>
    <div>
      <Text size={24} span>
        {value}
      </Text>
      {suffix && (
        <Text span size="sm">
          {" "}
          {suffix}
        </Text>
      )}
    </div>
  </Stack>
);
